"use strict";
var ApiMessageSeverity;
(function (ApiMessageSeverity) {
    ApiMessageSeverity[ApiMessageSeverity["Error"] = 0] = "Error";
    ApiMessageSeverity[ApiMessageSeverity["Warning"] = 1] = "Warning";
    ApiMessageSeverity[ApiMessageSeverity["Informational"] = 2] = "Informational";
    ApiMessageSeverity[ApiMessageSeverity["Fatal"] = 3] = "Fatal";
    ApiMessageSeverity[ApiMessageSeverity["Debug"] = 4] = "Debug";
})(ApiMessageSeverity = exports.ApiMessageSeverity || (exports.ApiMessageSeverity = {}));
//# sourceMappingURL=D:/a/1/s/base/src/models/api-message-severity.enum.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-message-severity.enum.js